/* tslint:disable */
/* eslint-disable */
/**
 * Courtiers API
 * API des listes de courtiers (facettes, tri, scope compagnie/admin)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Une entrée du journal de sécurité ABP.
 * @export
 * @interface ConnexionListItem
 */
export interface ConnexionListItem {
    /**
     * 
     * @type {string}
     * @memberof ConnexionListItem
     */
    id: string;
    /**
     * Date de l'événement (UTC)
     * @type {Date}
     * @memberof ConnexionListItem
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof ConnexionListItem
     */
    userName?: string | null;
    /**
     * LoginSucceeded, LoginFailed, ImpersonateUser, ChangePassword…
     * @type {string}
     * @memberof ConnexionListItem
     */
    action?: string | null;
    /**
     * Origine de l'événement (Identity, OpenIddict…)
     * @type {string}
     * @memberof ConnexionListItem
     */
    identity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnexionListItem
     */
    clientIpAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnexionListItem
     */
    browserInfo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnexionListItem
     */
    clientId?: string | null;
}

/**
 * Check if a given object implements the ConnexionListItem interface.
 */
export function instanceOfConnexionListItem(value: object): value is ConnexionListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    return true;
}

export function ConnexionListItemFromJSON(json: any): ConnexionListItem {
    return ConnexionListItemFromJSONTyped(json, false);
}

export function ConnexionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnexionListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'userName': json['userName'] == null ? undefined : json['userName'],
        'action': json['action'] == null ? undefined : json['action'],
        'identity': json['identity'] == null ? undefined : json['identity'],
        'clientIpAddress': json['clientIpAddress'] == null ? undefined : json['clientIpAddress'],
        'browserInfo': json['browserInfo'] == null ? undefined : json['browserInfo'],
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
    };
}

export function ConnexionListItemToJSON(json: any): ConnexionListItem {
    return ConnexionListItemToJSONTyped(json, false);
}

export function ConnexionListItemToJSONTyped(value?: ConnexionListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'date': ((value['date']).toISOString()),
        'userName': value['userName'],
        'action': value['action'],
        'identity': value['identity'],
        'clientIpAddress': value['clientIpAddress'],
        'browserInfo': value['browserInfo'],
        'clientId': value['clientId'],
    };
}

